import { getItem, setItem } from "../../plugins/localStorage"
import { getSlideMetadata } from "../../plugins/powerpoint"
import questionAPI from "../../api/question"
import uuidv4 from "uuid/v4"

const state = {
  appVersion: process.env.VUE_APP_VERSION || "0",
  isOffline: true,
  slideMetadata: {
    id: null,
    title: null,
    index: null,
  },
  contentApp: {},
}

const getters = {}

const actions = {
  async initStore({ dispatch, commit, rootState }, contentApp) {
    if (window.Office) {
      const localContentApp = getItem("contentApp")
      if (localContentApp !== null) {
        contentApp = localContentApp
      }
    } else {
      if (rootState.pilot.accessToken === null) {
        await this.dispatch("pilot/login", null, { root: true })
      }
      contentApp = { guid: 1, data: null }
    }
    commit("setContentApp", contentApp)
    dispatch("setSlideMetadata", contentApp)
  },

  setSlideMetadata({ commit, dispatch }, contentApp) {
    // Get the active powerpoint slide metadata (id, title, index)
    if (window.Office) {
      getSlideMetadata((slideMetadata) => {
        commit("setSlideMetadata", slideMetadata)

        let contentAppQuestionGuid = null
        if (contentApp !== null) {
          contentAppQuestionGuid = getItem("contentAppQuestionGuid[" + contentApp.guid + "]")
        }
        console.log("init store...")
        // first check if the slide already has a question attached
        if (contentAppQuestionGuid === null) {
          dispatch("setQuestion", "NEW")
        } else {
          dispatch("setQuestion")
        }
      })
    } else {
      // set test slide metadata if SmartQ is in web mode (not in a powerpoint context)
      commit("setSlideMetadata", { id: 1, title: "Smartq Web Test", index: 1 })
      const contentAppQuestionGuid = getItem("contentAppQuestionGuid[" + contentApp.guid + "]")
      // first check if the slide already has a question attached
      if (contentAppQuestionGuid === null) {
        dispatch("setQuestion", "NEW")
      } else {
        dispatch("setQuestion")
      }
    }
  },

  async setQuestion({ state, dispatch, commit, rootState }, contentAppQuestionGuid = null) {
    // retrieve pilot from cache
    dispatch("pilot/setOptionsFromSaved", null, { root: true })

    if (contentAppQuestionGuid === "NEW") {
      /* if (state.isOffline === false) {
        commit("live/setInactive", null, { root: true })
      } */
      dispatch("question/newQuestion", null, { root: true })
      dispatch("live/setOptionsFromSaved", null, { root: true })
      commit("live/setInactive", false, { root: true })
      dispatch("attachQuestionToSlide", rootState.question.guid_text)

      console.log("New question : ", rootState.question.guid_text)

      return
    }

    if (contentAppQuestionGuid !== null) {
      dispatch("attachQuestionToSlide", contentAppQuestionGuid)
    } else {
      // Get the question attached to this slide if exists
      contentAppQuestionGuid = getItem("contentAppQuestionGuid[" + state.contentApp.guid + "]")

      // !! FOR TEST PURPOSE ONLY, IF NO QUESTION SET INIT WITH 17-240
      /*if (contentAppQuestionGuid === null) {
        contentAppQuestionGuid = "C250AFF4-7617-4583-A7A6-DA2C65BDBEC1"
        dispatch("attachQuestionToSlide", contentAppQuestionGuid)
      }*/
    }

    let question, answers, labels, stack

    if (contentAppQuestionGuid) {
      question = getItem("question[" + contentAppQuestionGuid + "]")
      // if no question in local storage, try to retrieve it from api
      if (question === null) {
        if (!window.Office && rootState.pilot.accessToken === null) {
          await this.dispatch("pilot/login", null, { root: true })
        }
        let response = await questionAPI.getQuestion(contentAppQuestionGuid)

        response.data.answers.map((answer, index) => {
          response.data.answers[index].isSelected = false
          response.data.answers[index].isGroupTopLeft = false
          response.data.answers[index].isFirstTop = false
          response.data.answers[index].isTop = false
        })

        console.log(response.data.answers)

        answers = response.data.answers
        labels = response.data.labels
        setItem({ name: "question[" + contentAppQuestionGuid + "]", value: response.data })
        delete response["answers"]
        delete response["labels"]
        question = response.data
      } else {
        console.log("Retrieve data from cache ...")
        answers = question.answers
        labels = question.labels
        delete question["answers"]
        delete question["labels"]
      }

      commit("question/setQuestion", question, { root: true })
      commit("labels/setLabels", labels, { root: true })
      commit("answers/setAnswers", answers, { root: true })
      dispatch("labels/setOptionsFromSaved", null, { root: true })
      dispatch("labels/setSelectedFromSaved", null, { root: true })
      dispatch("live/setOptionsFromSaved", null, { root: true })
      dispatch("offline/setStackFromSaved", null, { root: true })

      console.log("Slide question : ", contentAppQuestionGuid)

      return
    }
  },

  attachQuestionToSlide({ state }, questionGuid) {
    console.log("attachQuestionToSlide[" + state.contentApp.guid + "]: " + questionGuid)
    setItem({ name: "contentAppQuestionGuid[" + state.contentApp.guid + "]", value: questionGuid })
  },

  reset({ state }) {
    setItem({ name: "contentAppQuestionGuid[" + state.contentApp.guid + "]", value: null })
  },

  clearStorage() {
    localStorage.clear()
    location.reload()
  },
}

const mutations = {
  setIsOffline(state, isOffline) {
    state.isOffline = isOffline
  },

  setSlideMetadata(state, slideMetadata) {
    state.slideMetadata = slideMetadata
  },

  setContentApp(state, contentApp) {
    state.contentApp = contentApp
    setItem({ name: "contentApp", value: contentApp })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
